import React from 'react';
import { Box, Card, Text, token, Paragraph } from '@zillow/constellation';
import { useFormContext } from 'react-hook-form';
import { getWholeDollars } from '../../utils/zhl-calculator.js';
import { useLastValidFormValues } from './LoanComparison.utils.js';

var OUTPUTS = [{
  label: 'Monthly payment',
  accessor: 'monthlyPayment'
}, {
  label: 'Total principal',
  accessor: 'totalPrincipal'
}, {
  label: 'Total interest',
  accessor: 'totalInterest'
}, {
  label: 'Pay-off date',
  accessor: 'payOffDate'
}];
var LoanComparisonResultCard = function LoanComparisonResultCard(props) {
  return /*#__PURE__*/React.createElement(Box, {
    as: Card
    // Make the cards width fluid
    ,
    sx: {
      flex: 1
    },
    cardType: "secondary",
    cardElevation: 0
  }, /*#__PURE__*/React.createElement(Text, {
    fontType: "h4",
    as: "p",
    textAlign: "center",
    paddingBottom: "md"
  }, props.headingText), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.coolGray100',
      paddingRight: '$spacing.sm',
      paddingLeft: '$spacing.sm',
      borderRadius: "" + token('radii.sm')
    }
  }, OUTPUTS.map(function (_ref, index) {
    var label = _ref.label,
      accessor = _ref.accessor;
    var isLastOutput = index !== OUTPUTS.length - 1;
    return /*#__PURE__*/React.createElement(Box, {
      key: accessor,
      sx: {
        alignItems: 'center',
        justifyContent: 'space-between',
        display: 'flex',
        paddingBottom: '$spacing.sm',
        paddingTop: '$spacing.sm',
        borderBottom: isLastOutput ? "2px solid $colors.borderLight" : null
      }
    }, /*#__PURE__*/React.createElement(Paragraph, null, label), /*#__PURE__*/React.createElement(Text, {
      fontType: "h4",
      paddingLeft: "sm",
      textAlign: "right"
    }, getWholeDollars(props.lastValidValues[props.loanType][accessor])));
  })));
};
var LoanComparisonResultForm = function LoanComparisonResultForm() {
  var form = useFormContext();
  var lastValidValues = useLastValidFormValues(form);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoanComparisonResultCard, {
    loanType: "typeOneCalculations",
    headingText: "Loan 1",
    lastValidValues: lastValidValues
  }), /*#__PURE__*/React.createElement(LoanComparisonResultCard, {
    loanType: "typeTwoCalculations",
    headingText: "Loan 2",
    lastValidValues: lastValidValues
  }), /*#__PURE__*/React.createElement(LoanComparisonResultCard, {
    loanType: "typeThreeCalculations",
    headingText: "Loan 3",
    lastValidValues: lastValidValues
  }));
};
var LoanComparisonResultForm$1 = LoanComparisonResultForm;

export { LoanComparisonResultCard, LoanComparisonResultForm$1 as default };
